import { useEffect, useState } from "react";
import { useLocale } from "../../i18n/LocaleContext";
import "./index.css";

const SHOW_AFTER_PX = 400;

function BackToTop() {
  const { t } = useLocale();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > SHOW_AFTER_PX);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      className={`back-to-top ${visible ? "is-visible" : ""}`}
      onClick={scrollTop}
      aria-label={t("backToTop")}
      title={t("backToTop")}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M12 5l7 7h-4v7h-6v-7H5l7-7z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
}

export default BackToTop;
